import {
  axiosInstance as axios,
  domain,
  setData,
  getData,
  deleteUserData,
} from "../utils/util";
import ADMIN_ACTIONS from "../actionTypes/admin_basic_actions";
import SET_LOADER from "../actionTypes/loader_set";
import { hist } from "../index";
import toastr from "toastr";
import MANAGE_CATEGORIES from "../actionTypes/manageCategories";

export  const login = (data) => async (dispatch) => {
  let payload = {
    email: data.email,
    password: data.password,
  };
  try {
    dispatch({
      type: SET_LOADER.LOADING,
      payload: true,
    });
    const response = await axios.post("/user/auth/signin", payload);
    if (response && response.data.statusCode === 200) {
      setData("BerPay_Admin", response.data.data);
      if (response.data.data && response.data.data.token) {
        dispatch({
          type: SET_LOADER.LOADING,
          payload: false,
        });
        hist.push("/admin/manageCustomers");
      } else {
        toastr.success("Email sent to registered email.");
        dispatch({
          type: SET_LOADER.LOADING,
          payload: false,
        });
      }
    } else {
      dispatch({
        type: SET_LOADER.LOADING,
        payload: false,
      });
      toastr.error(response.data.message);
    }
  } catch (error) {
    dispatch({
      type: SET_LOADER.LOADING,
      payload: false,
    });
  }

  // hist.push("/admin/viewTransactions");
  // let response = await axios.post(`${domain}/admin/login`, payload);
  //
  // if (
  //   response &&
  //   response.data &&
  //   response.data.statusCode &&
  //   response.data.statusCode === 200
  // ) {
  //
  //   setData('BerPay_Admin', {
  //     _id: response.data.data[0]['_id'],
  //     name: response.data.data[0]['name'],
  //     authToken: response.data.data[0]['authToken'],
  //     emailId: response.data.data[0]['emailId'],
  //     expiryDate: response.data.data[0]['expiryDate'],
  //     expiryToken: response.data.data[0]['expiryToken'],
  //   });
  //
  //   dispatch({
  //     type: ADMIN_ACTIONS.LOGIN,
  //     payload: response.data
  //   });
  //
  //   dispatch({
  //     type: SET_LOADER.LOADING,
  //     payload: false
  //   })
  //
  //   toastr.success(response.data.message)
  //   hist.push('/admin/dashboard');
  // }
  // else {
  //   toastr.error(response.data.message)
  //   dispatch({ type: SET_LOADER.LOADING, payload: false })
  // }
};

export const logout = () => async (dispatch) => {
  // let BerPay_Admin = getData("BerPay_Admin");
  // deleteUserData();
  localStorage.removeItem("BerPay_Admin");
  hist.push("/admin/pages/login-page");
  // let response = await axios.post(`${domain}/admin/logoutAdmin`, {
  //   _id: BerPay_Admin._id
  // });
  // if (
  //   response &&
  //   response.data &&
  //   response.data.statusCode &&
  //   response.data.statusCode === 200
  // ) {
  //   deleteUserData()
  //   toastr.success(response.data.message)
  //   hist.push('/admin/pages/login-page');
  // }
};

export const forgotPassword = (obj, cb) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADER.LOADING, payload: true });
    let response = await axios.get(
      `${domain}/user/auth/forget/${obj && obj.emailId}`
    );
    if (
      response &&
      response.data &&
      response.data.statusCode &&
      response.data.statusCode === 200
    ) {
      toastr.success("Email sent SuccessFully!");
      dispatch({ type: SET_LOADER.LOADING, payload: false });

      if (cb) cb();
    } else {
      toastr.error(response.data.message);
      dispatch({ type: SET_LOADER.LOADING, payload: false });
    }
  } catch (error) {
    dispatch({
      type: SET_LOADER.LOADING,
      payload: false,
    });
  }
};

export const resetPassword = (data, callback) => async (dispatch) => {
  try {
    dispatch({
      type: SET_LOADER.LOADING,
      payload: true,
    });
    const response = await axios.put("/user/change/password", data);
    if (response && response.data.statusCode === 200) {
      // console.log(response);
      dispatch({
        type: SET_LOADER.LOADING,
        payload: false,
      });
      toastr.success(response.data.message);
      hist.push("/admin/manageCustomers");
      window.location.reload();
      dispatch({
        type: SET_LOADER.LOADING,
        payload: false,
      });

      if (callback) {
        callback();
      }
    } else {
      toastr.error(response.data.message);
      dispatch({
        type: SET_LOADER.LOADING,
        payload: false,
      });
    }
  } catch (error) {
    dispatch({
      type: SET_LOADER.LOADING,
      payload: false,
    });
  }
};
export const setPassword = (obj, type) => async (dispatch) => {
  //dispatch({ type: SET_LOADER.LOADING, payload: true });
  //console.log("hey",type);

  let response = await axios.put(`${domain}/user/${type}/auth/password`, obj);
  if (
    response &&
    response.data &&
    response.data.statusCode &&
    response.data.statusCode === 200
  ) {
    toastr.success(response.data.message);
    hist.push("/admin/pages/login-page");
  } else {
    toastr.error(response.data.message);
  }
  // dispatch({ type: SET_LOADER.LOADING, payload: false });
};

export const uploadAdminProfile = (obj) => async (dispatch) => {
  dispatch({ type: SET_LOADER.LOADING, payload: true });
  //console.log("hey");
  let response = await axios.post(`/user/upload/profile/avatar`, obj);
  if (
    response &&
    response.data &&
    response.data.statusCode &&
    response.data.statusCode === 200
  ) {
    toastr.success(response.data.message);
  } else {
    toastr.error(response.data.message);
  }
  dispatch({ type: SET_LOADER.LOADING, payload: false });
};

export const updateAdminProfile = (obj, callback) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADER.LOADING, payload: true });
    //console.log("hey");
    let response = await axios.put(`/user/${obj._id}`, obj);
    if (
      response &&
      response.data &&
      response.data.statusCode &&
      response.data.statusCode === 200
    ) {
      //console.log(response.data.data);
      toastr.success(response.data.message);
      dispatch({ type: SET_LOADER.LOADING, payload: false });
      if (callback) {
        callback();
      }
    } else {
      dispatch({ type: SET_LOADER.LOADING, payload: false });
      toastr.error(response.data.message);
    }
  } catch (error) {
    dispatch({ type: SET_LOADER.LOADING, payload: false });
  }
};

// export const changePassword = (data) => async (dispatch) => {
//   // let { oldPassword, newPassword } = data;

// };

export const getCategoryData = () => async (dispatch) => {
  try {
    //console.log("hey");
    dispatch({
      type: SET_LOADER.LOADING,
      payload: true,
    });
    let response = await axios.get(`/user/customer/appuser/list`);
    //console.log("hey");
    if (response.data.statusCode === 200 || response.data.statusCode === 201) {
      dispatch({
        type: SET_LOADER.LOADING,
        payload: false,
      });
      dispatch({
        type: MANAGE_CATEGORIES.GET_CATEGORIES,
        payload: response.data.data,
      });
      toastr.success(response.data.message);
    } else {
      dispatch({
        type: SET_LOADER.LOADING,
        payload: false,
      });
      toastr.error(response.data.message);
    }
  } catch (error) {
    dispatch({
      type: SET_LOADER.LOADING,
      payload: false,
    });
  }
};
